"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrueToggle = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrueToggle = _react.default.forwardRef(function (_a, ref) {
  var sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["sx"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    ref: ref,
    as: "input"
  }, props, {
    type: "checkbox",
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: 1,
      width: (sx === null || sx === void 0 ? void 0 : sx.width) ? sx.width : '36px',
      height: (sx === null || sx === void 0 ? void 0 : sx.width) ? sx.width : '20px',
      overflow: 'hidden'
    }
  }));
});

exports.TrueToggle = TrueToggle;